import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import BottomNavigation from "@mui/material/BottomNavigation"
import BottomNavigationAction from "@mui/material/BottomNavigationAction"
import { homeButtons } from "../data/homepage"
import { useNavigate, useLocation } from "react-router-dom"
import { useOidc } from "@axa-fr/react-oidc"
import customStyle from "../styles/tokens.json"

export function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout } = useOidc()

  const signOutHandler = async () => {
    await logout("/")
  }

  const currentRouteIndex = homeButtons(signOutHandler)
    .slice(0, 4)
    .findIndex(
      (value) =>
        value.activePaths && value.activePaths.some((path) => location.pathname.startsWith(path))
    )

  const [value, setValue] = useState(currentRouteIndex !== -1 ? currentRouteIndex : 0)

  const handleChange = (newValue: number) => {
    setValue(newValue)
    navigate(homeButtons(signOutHandler)[newValue].href ?? "/")
  }

  useEffect(() => {
    setValue(currentRouteIndex)
  }, [currentRouteIndex])

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        boxShadow: "0px -2px 10px rgba(0,0,0,0.2)",
        zIndex: 1000,
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, newValue) => {
          handleChange(newValue)
        }}
        sx={{ backgroundColor: "#14213D" }}
      >
        {homeButtons(signOutHandler)
          .slice(0, 3)
          .map((button, index) => (
            <BottomNavigationAction
              key={button.href}
              value={index}
              onClick={() => {
                navigate(button.href ?? "/")
              }}
              label={button.title === "Transactions Report" ? "Transactions" : button.title}
              style={{
                backgroundColor:
                  button.href !== "/" &&
                  button.href !== undefined &&
                  button.activePaths &&
                  button.activePaths.some((path) => location.pathname.startsWith(path))
                    ? customStyle.components.buttons.secondary.color
                    : "transparent",
                color: "#ffffff",
              }}
              icon={<button.Icon {...button.iconProps} />}
            />
          ))}
      </BottomNavigation>
    </Box>
  )
}
